import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/** Controlled search box for client-side list filtering — shared across the plain-Table
 *  list pages (DataGrid's built-in quick-filter isn't available, see its project-wide ban). */
export function ListSearchField({
  value,
  onChange,
  placeholder = 'Ara...',
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <TextField
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={{ minWidth: 280 }}
    />
  );
}
